import { connect } from 'react-redux'
import Select from 'react-select'

import { useAppContext } from '@/App.context'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'
import { resetOrder, setAddressId, submitOrder } from '@/ducks/onboarding/onboardingActions'
import {
  getAddresses,
  getAllSelectedProducts,
  getOrderSum,
  getSelectedAddressId,
  orderIsLoading,
} from '@/ducks/onboarding/onboardingSelectors'
import useUser from '@/hooks/user'

import './step-confirm.scss'

const StepConfirm = ({
  addresses = [],
  selectedAddressId,
  setAddressId,
  submitOrder,
  products,
  orderSum,
  orderIsLoading,
  resetOrder,
}: any) => {
  const { whiteLabel } = useAppContext()
  const user = useUser()
  const costObjectId = user?.id

  return (
    <div id="step-confirm" className="step">
      <h2 className={whiteLabel}>
        <Translation id="Bekreft ordre" />
      </h2>

      <h3 className={whiteLabel}>{user?.name || 'Petter Nemeth'}</h3>

      <div className="products">
        {/* @ts-ignore */}
        {products.map((product, idx) => (
          <div key={idx} className="products__product">
            <div className="name">{product.productName || product.name}</div>
            <div className="price">
              <FormattedNumberWithCurrency amount={product.price} />
            </div>
          </div>
        ))}

        <div className="products__product total">
          <div className="name">
            <Translation id="Total" />
          </div>

          <div className="price">
            <FormattedNumberWithCurrency amount={orderSum} />
          </div>
        </div>
      </div>

      <h4 className={whiteLabel}>
        <Translation id="Velg leveringsadresse i listen under" />
      </h4>

      <SelectAddress
        addresses={addresses}
        value={selectedAddressId}
        // @ts-ignore
        onChange={address => setAddressId({ addressId: address.value, addressList: addresses })}
      />

      {selectedAddressId && !orderIsLoading && (
        <button onClick={() => submitOrder(costObjectId)} className={whiteLabel}>
          <Translation id="Bekreft ordre" />
        </button>
      )}

      {orderIsLoading && <div className="loader" />}

      <h3 className={whiteLabel}>
        <Translation id="Annen leveringsadresse?" />
      </h3>

      <p>
        <Translation id={`Hvis du av en eller annen grunn `} />
      </p>

      <p>
        <Translation id="Kontakt IT på helpdesk@multiconsult.no" />
      </p>

      <button onClick={resetOrder} className={`reset ${whiteLabel}`}>
        <Translation id="Slett bestilling" />
      </button>
    </div>
  )
}

const SelectAddress = ({ addresses, value, onChange }: any) => {
  // @ts-ignore
  const options = addresses.map(address => ({
    value: address.id,
    label: `${address.city.toUpperCase()} - ${address.address} `,
  }))

  return (
    <Select
      placeholder={<Translation id="Leveringsadresse" />}
      options={options}
      onChange={onChange}
      // @ts-ignore
      value={options.filter(option => option.value === value)}
      className="react-select"
    />
  )
}

// @ts-ignore
const mapStateToProps = state => ({
  addresses: getAddresses(state),
  selectedAddressId: getSelectedAddressId(state),
  products: getAllSelectedProducts(state),
  orderSum: getOrderSum(state),
  orderIsLoading: orderIsLoading(state),
})

const mapDispatchToProps = {
  setAddressId,
  submitOrder,
  resetOrder,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepConfirm)
